
import SliderNav from './includes/slide-nav';
import stickySidebar from './includes/sticky-sidebar';
import toggleMainNav from './includes/main-nav';



stickySidebar({
    sidebar: '.side-nav',
    headings: '.content-text__title',
    stoppers: '.main-footer',
});



document.querySelector('.toggle-main-nav')
  .addEventListener('click', toggleMainNav);

document.querySelector('.scroll-to-top')
  .addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });



window.onload = () => {
    document.querySelectorAll('.slider')
        .forEach(slider => {
            new SliderNav(slider);
        });
};


(function ($) {

  $(document).ready(function () {
    $("a").on('click', function (event) {
      if (this.hash !== "") {
        event.preventDefault();

        var hash = this.hash;

        $('html, body').animate({
          scrollTop: $(hash).parent().offset().top + 2
        });

      }
    });
  });


  $('.toggle-more__button').on('click', () => {
    $('.toggle-more')
      .height($('.toggle-more p').height())
      .addClass('open');
  });

})(jQuery);



const notificationBar = document.querySelector('.notification-bar');
if ( notificationBar ) {
  const closeNotificationButton = notificationBar.querySelector('.notification-bar__close-btn');

  closeNotificationButton.addEventListener('click', evt => {
    evt.preventDefault();

    const nextWeekDate = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000);
    document.cookie = `notificationBar=hidden; expires=${nextWeekDate.toUTCString()}`;

    const height = notificationBar.getBoundingClientRect().height;
    notificationBar.style.marginTop = `-${height}px`;
  });
}






const toggleBlocks = document.querySelectorAll('.toggle-block');
toggleBlocks
  .forEach(block => block.addEventListener('click', () => {
    block
      .querySelector('.toggle-block__content')
      .classList.toggle('visible');
  }));




const homeHeader = document.querySelector('body.home .main-header__title');
if ( homeHeader ) {
  function setupHomeHeaderImage () {
    const height = homeHeader.getBoundingClientRect().height;
    homeHeader.style.setProperty('--height', `${height}px`);
  }

  document.addEventListener('DOMContentLoaded', setupHomeHeaderImage);
  window.addEventListener('resize', setupHomeHeaderImage);
}




const clientsSlider = document.querySelector('.clients-list__slider');
if ( clientsSlider ) {
  let currentSlide = 0;
  const delay = 5000;

  const slides = clientsSlider.querySelectorAll('.clients-list__slide');
  const navBtns = clientsSlider.querySelectorAll('nav button');
  navBtns
    .forEach(btn => btn.addEventListener('click', () => {
      currentSlide = btn.dataset.id - 1;
      setSlide();
    }));

  let timeout = window.setTimeout(nextSlide, delay);
  setSlide(currentSlide);



  function nextSlide () {
    currentSlide++;
    if ( currentSlide >= slides.length ) {
      currentSlide = 0;
    }

    setSlide();
  }

  function setSlide () {
    clearTimeout(timeout);

    slides
      .forEach(slide => slide.classList.remove('current'));

    navBtns
      .forEach(btn => btn.classList.remove('current'));

    slides[currentSlide].classList.add('current');
    navBtns[currentSlide].classList.add('current');

    timeout = window.setTimeout(nextSlide, delay);
  }
}
